<div class="ui label disabled item">
    {{ label }}
    @if (removable) {
        <ui-button size="no-padding" variant="icon" (click)="onRemove()">
            <mat-icon svgIcon="close" />
        </ui-button>
    }
</div>
